var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrgMgmt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 0H17.5C17.9641 0 18.4092 0.188764 18.7374 0.524767C19.0656 0.86077 19.25 1.31649 19.25 1.79167V32.25H0V1.79167C0 1.31649 0.184374 0.86077 0.512563 0.524767C0.840752 0.188764 1.28587 0 1.75 0ZM5.25 5.375H8.75V8.95833H5.25V5.375ZM10.5 5.375H14V8.95833H10.5V5.375ZM5.25 12.5417H8.75V16.125H5.25V12.5417ZM10.5 12.5417H14V16.125H10.5V12.5417ZM5.25 19.7083H8.75V23.2917H5.25V19.7083ZM10.5 19.7083H14V23.2917H10.5V19.7083ZM7.875 26.875H11.375V32.25H7.875V26.875Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 10.75H29.75C30.2141 10.75 30.6592 10.9388 30.9874 11.2748C31.3156 11.6108 31.5 12.0665 31.5 12.5417V32.25H21V12.5417C21 12.0665 21.1844 11.6108 21.5126 11.2748C21.8408 10.9388 22.2859 10.75 22.75 10.75ZM24.5 16.125H28V19.7083H24.5V16.125ZM24.5 23.2917H28V26.875H24.5V23.2917Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrgMgmt);
export default __webpack_public_path__ + "static/media/icon_org-mgmt.609b9be5109f1adde1ec8a56cf887a4f.svg";
export { ForwardRef as ReactComponent };